import React, { useEffect, useState } from 'react';
export function UrgencyBar() {
  // Start at 59 minutes and 59 seconds
  const [timeLeft, setTimeLeft] = useState(59 * 60 + 59);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 0);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  return <div className="sticky top-0 z-50 bg-red-700 text-white text-center py-2.5 px-4 text-xs sm:text-sm font-medium tracking-wide shadow-md flex items-center justify-center gap-2" data-id="element-134">
      <span className="animate-pulse w-2 h-2 bg-white rounded-full inline-block" data-id="element-135"></span>
      LAUNCH OFFER: 85% DISCOUNT ENDS TODAY. [{formattedTime}]
    </div>;
}